import { CrudPage } from '@restavo/crud';
import React from 'react';
import { useMenuItemsPage } from 'src/features/menuItems';

const MenuItemsSettings = React.memo(() => {
  const { page, imagesViewer } = useMenuItemsPage();
  return (
    <>
      <CrudPage {...page} />
      {imagesViewer}
    </>
  );
});

export default MenuItemsSettings;
